import { Stack, Typography } from "@mui/material";

const OtherOptionsWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <Stack sx={{ py: 1.5 }}>
      <Typography variant="subtitle1" sx={{ pl: 2, py: 1 }}>
        Other
      </Typography>
      {children}
    </Stack>
  );
};

export default OtherOptionsWrapper;
